module.exports = (fieldInfo) => {
  const {
    fieldName,
    type,
    toggle,
    className,
    labelTxt,
    maxlength,
    placeholder
    // labelArray,
    // mode,
    // options,
    // maxlenth,
    // minlenth,
    // defaultValue,
  } = fieldInfo;

  // select 需要搜索的字段
  const selectFilterable =  ['province', 'city', 'barangay', 'cityOfBirth', 'citizenship', 'city_1']
  const filterable = selectFilterable.includes(fieldName)
  
  const fieldTypes = {
    'Input'() {

      return `<el-form-item ${className ? `class="${className}"` : ""} ${ toggle ? `v-show="${ toggle }"` : '' } label="${ labelTxt }" prop="${ fieldName }">
        <el-input v-model="dFormData.${ fieldName }"  placeholder="${ placeholder }" ${maxlength ? `maxlength="${maxlength}"` : ""} :clearable="${fieldName == 'email' ? 'false' : '!disabled'}" :disabled="disabled"></el-input>
      </el-form-item>`;
    },
    'MobileNumber'() {

      return `<el-form-item ${ toggle ? `v-show="${ toggle }"` : '' } label="${ labelTxt }" prop="${ fieldName }">
        <MobileNumber v-model="dFormData.${ fieldName }"></MobileNumber>
      </el-form-item>`;
    },
    'Select'() {

      return `<el-form-item label="${ labelTxt }" prop="${ fieldName }">
        <bdo-select v-model="dFormData.${ fieldName }"  placeholder="${ placeholder }" :options="options.${fieldName}" :disabled="disabled" :filterable="${filterable}"></bdo-select>
      </el-form-item>`;
    },
    'ImgUploader'() {

      return `<el-form-item label="${ labelTxt }">
        <el-input v-model="dFormData.${ fieldName }"  placeholder="${ placeholder }"></el-input>
      </el-form-item>`;
    },
    'Checkbox'() {

      return `<el-form-item label="${ labelTxt }" prop="${ fieldName }">
        <el-input v-model="dFormData.${ fieldName }"  placeholder="${ placeholder }"></el-input>
      </el-form-item>`;
    },
    'CountrySelector'() {

      return `<el-form-item label="${ labelTxt }" prop="${ fieldName }">
        <el-input v-model="dFormData.${ fieldName }"  placeholder="${ placeholder }"></el-input>
      </el-form-item>`;
    },
    'SelectDate'() {

      // <el-date-picker v-model="dFormData.${ fieldName }" type="date" placeholder="${ placeholder }" format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
      return `<el-form-item label="${ labelTxt }" prop="${ fieldName }">
        <SelectDate v-model="dFormData.${ fieldName }" />
      </el-form-item>`;
    },
    'BdoRadio'() {

      return `<el-form-item label="${ labelTxt }">
        <bdo-radio v-model="dFormData.${ fieldName }" :labelArray="bdoRadioLabelArray" :mode="bdoRadioMode" ></bdo-radio>
      </el-form-item>`;
    },
    'LandlineNumber'() {

      return `<el-form-item label="${ labelTxt }" ${ toggle ? `v-show="${ toggle }"` : '' } prop="${ fieldName }">
        <LandlineNumber v-model="dFormData.${ fieldName }"></LandlineNumber>
      </el-form-item>`;
    },
    'ProvinceSelect'() {

      return `<el-form-item label="${ labelTxt }" ${ toggle ? `v-show="${ toggle }"` : '' } prop="${ fieldName }">
        <ProvinceSelect v-model="dFormData.${ fieldName }" :disabled="disabled"></ProvinceSelect>
      </el-form-item>`;
    },
    'CityAndZipCode'() {
      return `<el-form-item label-width="auto" label="City / Municipality" ${ toggle ? `v-show="${ toggle }"` : '' } prop="${ fieldName }">
        <template v-slot:label>
          <label>
            City / Municipality
          </label>
          <label style="position: absolute;right: 383px;">
            Zip Code
          </label>
        </template>
        <CityAndZipCode v-model="dFormData.cityAndZipCode" :province="formData.homeProState || formData.busiStoreProState || formData.branchProState"></CityAndZipCode>
      </el-form-item>`;
    },
    'BusinessNatrue'() {
      return `<el-form-item label="${ labelTxt }" ${ toggle ? `v-show="${ toggle }"` : '' } prop="${ fieldName }">
        <BusinessNatrue v-model="dFormData.${ fieldName }" :agencyBanking="agencyBanking"></BusinessNatrue>
      </el-form-item>`;
    },
    'BusinessDescrption'() {
      return `<el-form-item label="${ labelTxt }" ${ toggle ? `v-show="${ toggle }"` : '' } prop="${ fieldName }">
        <BusinessDescrption v-model="dFormData.${ fieldName }" :agencyBanking="agencyBanking" :busiNature="formData.busiNature"></BusinessDescrption>
      </el-form-item>`;
    },
  }

  const getExtraMarkup = () => {
    console.log(`getExtraMarkup: fieldName === ${ fieldName }`)
    if (fieldName === '') {
      return `<div class="el-form-item"></div>`
    }

    if (fieldName === '---') {
      return `<hr class="divider" />`
    }

    return '';

  };

  return fieldTypes[type] ? fieldTypes[type]() : getExtraMarkup();
};
